/**
 * @summary This is the file that custom client config changes can be made.
 * Make changes within the custom component config objects
 * @module appConfigMain
 */
import headerConfig, { AlmeHeaderConfig } from '../../components/AlmeHeader/AlmeHeaderConfig';
import appConfig, { AlmeAppConfig } from '../../components/AlmeApp/AlmeAppConfig';
import historyConfig, { AlmeHistoryConfig } from '../../components/AlmeHistory/AlmeHistoryConfig';
import apiUtilsConfig, { AlmeApiUtilsConfig } from '../../api/AlmeApiUtilsConfig';
import footerConfig, { AlmeFooterConfig } from '../../components/AlmeFooter/AlmeFooterConfig';
import launchPointConfig, { AlmeLaunchPointConfig } from '../../components/AlmeLaunchPoint/AlmeLaunchPointConfig';
import liveChatControlsConfig, { AlmeLiveChatControlsConfig } from '../../components/LiveChat/AlmeLiveChatControls/AlmeLiveChatControlsConfig';
import themeModeToggleConfig, { AlmeThemeModeToggleConfig } from '../../components/AlmeThemeModeToggle/AlmeThemeModeToggleConfig';
import { AlmeConfig } from '../../models/AlmeConfig';
import launchToolsConfig, { AlmeLaunchToolsConfig } from '../../components/AlmeLaunchTools/AlmeLaunchToolsConfig';


const customAppConfig: AlmeAppConfig = {
    ...appConfig,
};

const customApiUtilsConfig: AlmeApiUtilsConfig = {
    ...apiUtilsConfig,
};

const customHeaderConfig: AlmeHeaderConfig = {
    ...headerConfig,
};

const customHistoryConfig: AlmeHistoryConfig = {
    ...historyConfig,
};

const customFooterConfig: AlmeFooterConfig = {
    ...footerConfig,
};

const customLaunchPointConfig: AlmeLaunchPointConfig = {
    ...launchPointConfig,
    launchPoint: {
        // Note: to disable global launch comment all of these settings.
        ...launchPointConfig.launchPoint,
        //buttonText: 'Need Help?',
        //inputFieldText: 'Ask IVA',
    },
};

const customLiveChatControlsConfig: AlmeLiveChatControlsConfig = {
    ...liveChatControlsConfig,
};

const customThemeModeToggleConfig: AlmeThemeModeToggleConfig = {
    ...themeModeToggleConfig,
};

const customLaunchToolsConfig: AlmeLaunchToolsConfig = {
    ...launchToolsConfig,
};

const appConfigMain: AlmeConfig = {
    ...customAppConfig,
    ...customApiUtilsConfig,
    ...customHeaderConfig,
    ...customHistoryConfig,
    ...customFooterConfig,
    ...customLaunchPointConfig,
    ...customLiveChatControlsConfig,
    ...customThemeModeToggleConfig,
    ...customLaunchToolsConfig,
};

export default appConfigMain;